import * as T from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <T.Provider delayDuration={200}>{children}</T.Provider>;
}

export function Tooltip({ content, children, side = "top" }: {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
}) {
  if (!content) return <>{children}</>;
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={6}
          className="z-50 max-w-xs rounded-md bg-gray-900 px-2.5 py-1.5 text-xs text-white shadow-lg data-[state=delayed-open]:animate-in data-[state=closed]:animate-out"
        >
          {content}
          <T.Arrow className="fill-gray-900" />
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
